// extracted by mini-css-extract-plugin
module.exports = {"DashboardCard":"DashboardCard_DashboardCard__4XHHY","Title":"DashboardCard_Title__2s0g9"};